









import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    componentDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    FETCH_PRODUCT_DATA
} from "../store/actions.names";
import VueProductSpinner from "vue-product-spinner";
const images = [...Array(51)].map(
    (_, i) =>
    `https://raw.githubusercontent.com/micheleriva/vue-product-spinner/master/public/imgs/honda/${i +
      1}.png`
);
@Component({
    name: "ProductView",
    components: {
        VueProductSpinner
    }
})
export default class ProductView extends Vue {

    @Prop() public compData!: string | null;
    data() {
        return {
            imgs: images
        };
    }
}
